export enum EnvironmentType {
  "development" = "development",
  "homolog" = "homolog",
  "production" = "production",
  "hext" = "hext",
}
export const HOMOLOG_URL = "https://h-diariodonordeste.verdesmares.com.br/";
export const PRODUCTION_URL = "https://diariodonordeste.verdesmares.com.br/";
